import { Download } from "@monta/icons";
import styles from "./styles.module.scss";

const DownloadBtn = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className={styles["download-container"]}>
      <div className={styles["download-container__title"]}>
        اطلاعات کلی کارنامه
      </div>
      <button
        type="button"
        className={styles["download-container__download"]}
        onClick={onClick}
      >
        دانلود کارنامه
        <Download size={15} />
      </button>
    </div>
  );
};

export default DownloadBtn;
